import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {
    setBankingAgreementsReportAdminRequestData,
    setBankingAgreementsReportAdminResponseData,
} from "../../../../_reducers/DataPanel/Accounting/accountingSlice";
import axios from "axios";
import {toast} from "react-toastify";
import moment from "moment/moment";
import {jsPDF} from "jspdf";
import {liberationSerif} from "../../../../fonts/liberationSerif";
import {dejavuSans} from "../../../../fonts/DejaVuSans-normal";
import {dejavuSansBold} from "../../../../fonts/DejaVuSans-Bold-bold";
import {autoTable} from "jspdf-autotable";
import {isEmpty} from "../../../../_helpers/commonFunctions";
import * as XLSX from "xlsx";
import {Badge, Col, Row, Spinner} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import DateBox from "../../../primer/DateBox";
import Dropdown from "../../../primer/Dropdown";
import Pagination from "../../../primer/Pagination";
import BootstrapDropdown from "react-bootstrap/Dropdown";
import Input from "../../../common/Input";

const AccountingBankingAgreementsAdmin = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const requestData = useSelector((state) => state.ACCOUNTING_DATA.bankingAgreementsAdminRequestData);
    const responseData = useSelector((state) => state.ACCOUNTING_DATA.bankingAgreementsAdminResponseData);

    const [extraInfoAgreements, setExtraInfoAgreements] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageChanged, setPageChanged] = useState(true);

    const statusOptions = [
        {label: "Προβολή όλων", value: ""},
        {label: "Μόνο επιτυχημένων", value: "success"},
        {label: "Μόνο αποτυχημένων", value: "fail"},
        {label: "Μόνο ληγμένων", value: "expired"},
        {label: "Μόνο ακυρωμένων", value: "cancelled"},
    ]

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchReport(true);
        }
    }, [pageChanged]);

    const fetchReport = (fromPagination = false, showMsg = true) => {
        setLoading(true);
        const reqData = {...requestData};
        if (!fromPagination) {
            reqData.page = 1;
            dispatch(setBankingAgreementsReportAdminRequestData(reqData));
        }
        axios.get(`${process.env.REACT_APP_API_URL2}/accounting/banking-agreements-admin`, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                ...reqData,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                if (!fromPagination) {
                    if (res.data.data.totalPages > 0) {
                        if (showMsg) toast.success("Τα δεδομένα ανανεώθηκαν.", {autoClose: 1000});
                    } else {
                        if (showMsg) toast.info("Δεν βρέθηκαν διασυνδέσεις.", {autoClose: 1000});
                    }
                }
                dispatch(setBankingAgreementsReportAdminResponseData({...responseData, data: res.data.data.data, totalPages: res.data.data.totalPages}));
            } else {
                if (showMsg) toast.error(res.data.message);
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            if (showMsg) toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const fetchReportNoPagination = async (showMsg = true) => {
        const reqData = {...requestData};
        reqData.page = -1;
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL2}/accounting/banking-agreements-admin`, {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    ...reqData,
                },
            });

            if (res.data.status === "200") {
                return res.data.data.data;
            } else {
                if (showMsg) toast.error(res.data.message);
            }
        } catch (err) {
            console.log(err);
            if (showMsg) toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        }
    }

    const handlePageChange = (page) => {
        dispatch(setBankingAgreementsReportAdminRequestData({...requestData, page: page}));
        setPageChanged(true);
    }

    const handleOnChange = (e, type, name) => {
        const prepChanges = {};
        if (type === "dd") {
            prepChanges[name] = e.value;
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChanges[name] = moment(e).format("DD/MM/YYYY");
            } else {
                prepChanges[name] = "";
            }
        } else if (type === "input") {
            prepChanges[name] = e.target.value;
        }
        dispatch(setBankingAgreementsReportAdminRequestData({...requestData, ...prepChanges}));
    }

    const formatStatus = (agrementStatus) => {
        if (agrementStatus === "success") {
            return "Επιχημένη";
        } else if (agrementStatus === "fail") {
            return "Αποτυχημένη";
        } else if (agrementStatus === "expired") {
            return "Έχει λήξει";
        } else if (agrementStatus === "cancelled") {
            return "Ακυρωμένη";
        }
        return agrementStatus;
    }

    const handlePDFExport = async () => {
        let rows = [];

        const headerColumns = ["Εταιρεία", "Κωδικός Διασύνδεσης", "Χρηματοπιστωτικό Ίδρυμα", "Έναρξη Διασύνδεσης", "Λήξη Διασύνδεσης", "Κατάσταση Διασύνδεσης"]
        const responseData = await fetchReportNoPagination();
        for (let d of responseData) {
            rows.push([
                d.companyIdentifier,
                d.agreementId,
                d.agreementInstitutionId,
                moment(d.agreementDate).isValid() ? moment(d.agreementDate).format("DD/MM/YYYY HH:mm:ss") : d.agreementDate,
                moment(d.agreementEndDate).isValid() ? moment(d.agreementEndDate).format("DD/MM/YYYY HH:mm:ss") : d.agreementEndDate,
                formatStatus(d.status),
            ])
        }
        const doc = new jsPDF('landscape');
        let y = 20;
        doc.addFileToVFS("arialuni.ttf", liberationSerif);
        doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
        doc.addFileToVFS("dejavusans.ttf", dejavuSans);
        doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
        doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
        doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");
        doc.setFont("DejaVu Sans Bold");
        doc.setFontSize(10);
        const header = doc.splitTextToSize(`Τραπεζικές Διασυνδέσεις`, 200);
        const headerString = header.join("\n");
        doc.text(headerString, doc.internal.pageSize.getWidth() / 4, 9, {alignment: "center"});
        doc.setFont("DejaVu Sans Normal");
        const imgData = 'assets/images/prrimer-logo.png';
        const imgX = doc.internal.pageSize.getWidth() - 45; // adjust the position as needed
        const imgY = 3; // adjust the position as needed
        doc.addImage(imgData, 'PNG', imgX, imgY, 40, 15);
        doc.setFont("DejaVu Sans Normal");
        autoTable(doc, {
            startY: y,
            head: [headerColumns],
            body: rows,
            rowPageBreak: "avoid",
            styles: {
                font: "DejaVu Sans Normal",
                fontStyle: "normal",
                fontSize: 8, // set font size
                halign: "center", // set alignment
            },
        })
        const pageCount = doc.getNumberOfPages();
        // Add the pagination to each page
        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(10);
            doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
        }
        doc.save(`Τραπεζικές Διασυνδέσεις.pdf`);
    }

    const handleExcelExport = async () => {
        let rows = [];
        const dateExported = moment().format("DD/MM/YYYY HH:mm:ss");
        const responseData = await fetchReportNoPagination();
        if (!isEmpty(requestData.date_from) && !isEmpty(requestData.date_to)) rows.push(["Εύρος ημερομηνίας:", `${requestData.date_from} - ${requestData.date_to}`]);
        rows.push(["Επωνυμία:", company.name]);
        rows.push(["ΑΦΜ:", company.vatNumber]);
        rows.push(["Ημερομηνία Εξαγωγής:", dateExported]);
        rows.push([]);
        rows.push(["Εταιρεία", "Κωδικός Διασύνδεσης", "Χρηματοπιστωτικό Ίδρυμα", "Έναρξη Διασύνδεσης", "Λήξη Διασύνδεσης", "Κατάσταση Διασύνδεσης"]);
        for (let d of responseData) {
            rows.push([
                d.companyIdentifier,
                d.agreementId,
                d.agreementInstitutionId,
                moment(d.agreementDate).isValid() ? moment(d.agreementDate).format("DD/MM/YYYY HH:mm:ss") : d.agreementDate,
                moment(d.agreementEndDate).isValid() ? moment(d.agreementEndDate).format("DD/MM/YYYY HH:mm:ss") : d.agreementEndDate,
                formatStatus(d.status),
            ])
        }

        const workSheet = XLSX.utils.aoa_to_sheet(rows);

        workSheet['!cols'] = [
            { wch: 40 },
            { wch: 30 },
            { wch: 30 },
            { wch: 30 },
            { wch: 30 }
        ];

        const workBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, workSheet, "Τραπεζικές Διασυνδέσεις");
        XLSX.writeFile(workBook, 'Τραπεζικές Διασυνδέσεις.xlsx');
    }

    return (
        <React.Fragment>
            <div>
                <Row onKeyDown={(e) => {
                    if (e?.key === "Enter") fetchReport(false);
                }}>
                    <Col md={2}>
                        <DateHelper
                            dateFromAndToFunction={(from, to) => dispatch(setBankingAgreementsReportAdminRequestData({...requestData, date_from: from, date_to: to}))}
                        />
                    </Col>
                    <Col md={2}>
                        <DateBox
                            name="date_from"
                            selected={moment(requestData.date_from, "DD/MM/YYYY").isValid() ? moment(requestData.date_from, "DD/MM/YYYY").toDate() : ""}
                            label={"Ημερομηνία έναρξης από"}
                            allowOtherYears={true}
                            onChange={(e) => handleOnChange(e, "datebox", "date_from")}
                        />
                    </Col>
                    <Col md={2}>
                        <DateBox
                            name="date_to"
                            selected={moment(requestData.date_to, "DD/MM/YYYY").isValid() ? moment(requestData.date_to, "DD/MM/YYYY").toDate() : ""}
                            label={"Ημερομηνία έναρξης έως"}
                            allowOtherYears={true}
                            onChange={(e) => handleOnChange(e, "datebox", "date_to")}
                        />
                    </Col>
                    <Col md={4}>
                        <Input
                            name={"company"}
                            label={"Όνομα Εταιρείας / ΑΦΜ"}
                            value={requestData.company}
                            onChange={(e) => handleOnChange(e, "input", "company")}
                        />
                    </Col>
                    <Col md={2}>
                        <Dropdown
                            name={"status"}
                            label={"Κατάσταση διασύνδεσης"}
                            options={statusOptions}
                            defaultValue={statusOptions.find((el) => el.value === requestData.status)}
                            onChange={(e) => handleOnChange(e, "dd", "status")}
                        />
                    </Col>
                </Row>
                <Row className={"d-flex justify-content-end"}>
                    <Col md={2} className={"d-flex justify-content-end"}>
                        <Button onClick={() => fetchReport(false)} disabled={loading}>
                            Αναζήτηση
                            {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                        </Button>
                    </Col>
                </Row>
                {responseData.totalPages > 0 && (
                    <React.Fragment>
                        <Row className={"mt-2"}>
                            <Col md={12} className={"d-flex justify-content-end"}>
                                <Pagination
                                    currentPage={requestData.page}
                                    totalPages={responseData.totalPages}
                                    handlePageChange={(page) => handlePageChange(page)}
                                />
                            </Col>
                        </Row>
                        <Row className={"mt-2"}>
                            <Col md={12}>
                                <table className={"simpleClassicTable"} style={{fontSize: "12px"}}>
                                    <colgroup>
                                        <col span={1} style={{width: "5%"}}></col>
                                        <col span={1} style={{width: "25%"}}></col>
                                        <col span={1} style={{width: "15%"}}></col>
                                        <col span={1} style={{width: "15%"}}></col>
                                        <col span={1} style={{width: "15%"}}></col>
                                        <col span={1} style={{width: "15%"}}></col>
                                        <col span={1} style={{width: "10%"}}></col>
                                    </colgroup>
                                    <thead>
                                    <tr>
                                        <th>{" "}</th>
                                        <th>Εταιρεία (ΑΦΜ)</th>
                                        <th>Κωδικός Διασύνδεσης</th>
                                        <th>Χρηματοπιστωτικό Ίδρυμα</th>
                                        <th>Έναρξη Διασύνδεσης</th>
                                        <th>Λήξη Διασύνδεσης</th>
                                        <th>Κατάσταση Διασύνδεσης</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {responseData.data.map((agreement, idx) => (
                                        <React.Fragment>
                                            <tr key={`aba-${idx}`}>
                                                <td>{agreement.requisitionSuccess === true && (
                                                    <React.Fragment>
                                                        {extraInfoAgreements.includes(agreement._id) ? (
                                                            <Badge bg={"primary"} style={{cursor: "pointer"}} onClick={() => setExtraInfoAgreements(extraInfoAgreements.filter((el) => el !== agreement._id))}>-</Badge>
                                                        ) : (
                                                            <Badge title={"Εμφάνιση πληροφοριών"} bg={"primary"} style={{cursor: "pointer"}} onClick={() => setExtraInfoAgreements([...extraInfoAgreements, agreement._id])}>+</Badge>
                                                        )}
                                                    </React.Fragment>
                                                )}</td>
                                                <td>{agreement.companyIdentifier}</td>
                                                <td>{agreement.agreementId}</td>
                                                <td>{agreement.agreementInstitutionId}</td>
                                                <td>{moment(agreement.agreementDate).isValid() ? moment(agreement.agreementDate).format("DD/MM/YYYY HH:mm:ss") : agreement.agreementDate}</td>
                                                <td>{moment(agreement.agreementEndDate).isValid() ? moment(agreement.agreementEndDate).format("DD/MM/YYYY HH:mm:ss") : agreement.agreementEndDate}</td>
                                                <td>{formatStatus(agreement.status)}</td>
                                            </tr>
                                            {extraInfoAgreements.includes(agreement._id) && (
                                                <tr style={{backgroundColor: "#f5f5f5", textAlign: "left"}}>
                                                    <td colSpan={6}>
                                                        <div className={"p-2"}>
                                                            <h6>Τραπεζικοί Λογαριασμοί:</h6>
                                                            <Row>
                                                                {agreement?.accounts?.length > 0 && agreement?.accounts?.map((acc, idx2) => (
                                                                    <Col md={4} key={`connectedBanks-${idx}-${idx2}`}>
                                                                        <div style={{border: "1px solid lightgray", width: "100%", padding: "5px", borderRadius: "5px", backgroundColor: "white"}}>
                                                                            <strong>IBAN: </strong> {acc.iban}<br/>
                                                                            <strong>Νόμισμα: </strong> {acc.currency}<br/>
                                                                            <strong>Όνομα Ιδιοκτήτη: </strong> {acc.ownerName}<br/>
                                                                            <strong>Τραπεζικό Προϊόν: </strong> {acc.product}<br/>
                                                                            <div style={{textAlign: "center"}} className={"pt-1"}>
                                                                                {acc.hooked === true ? (
                                                                                    <Badge bg={"success"}>Διασυνδεδεμένος</Badge>
                                                                                ) : (
                                                                                    <Badge bg={"danger"}>Μη διασυνδεδεμένος</Badge>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                ))}
                                                            </Row>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    ))}
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                        <Row>
                            <BootstrapDropdown className="mb-3 mt-3">
                                <BootstrapDropdown.Toggle variant="primary" id="dropdown-basic">
                                    Αποθήκευση αποτελεσμάτων
                                </BootstrapDropdown.Toggle>
                                <BootstrapDropdown.Menu>
                                    <BootstrapDropdown.Item onClick={() => handlePDFExport()}>
                                        Αποθήκευση ως PDF
                                    </BootstrapDropdown.Item>
                                    <BootstrapDropdown.Item onClick={() => handleExcelExport()}>
                                        Αποθήκευση ως XLSX
                                    </BootstrapDropdown.Item>
                                </BootstrapDropdown.Menu>
                            </BootstrapDropdown>
                        </Row>
                    </React.Fragment>
                )}
            </div>
        </React.Fragment>
    )
}

export default AccountingBankingAgreementsAdmin;
